const COURIERED_DELIVERY_TYPES = {
    DEFAULT_BASIC: 19,
    DEFAULT_OVERNIGHT: 20,
    DEFAULT_CANADA_BASIC: 21,
    DEFAULT_CANADA_OVERNIGHT: 22,
    DEFAULT_US_CANADA: 23,
    DEFAULT_SATURDAY: 24,
    DEFAULT_INTERNATIONAL: 25,
    PREPAID_CARD_UPS_BASIC: 31,
    PREPAID_CARD_UPS_OVERNIGHT: 32,
    PREPAID_CARD_UPS_CANADA_BASIC: 33,
    PREPAID_CARD_UPS_CANADA_OVERNIGHT: 34,
    PREPAID_CARD_UPS_US_CANADA: 35,
    PREPAID_CARD_UPS_SATURDAY: 36,
    PREPAID_CARD_UPS_INTERNATIONAL: 37,
}

const TICKETMASTER_DELIVERY_TYPES = {
    ELECTRONIC_TRANSFER: 26,
    TEXT_MOBILE_TRANSFER: 43,
    INSTANT_TRANSFER: 41,
}

function isCourieredDelivery(id) {
    return Object.values(COURIERED_DELIVERY_TYPES).indexOf(id) > -1
}

const INSTANT_DELIVERY_TYPES = {
    INSTANT_DOWNLOAD: 18,
    INSTANT_FLASH_SEATS: 42,
    INSTANT_TRANSFER: 41,
    MOBILE_ETICKET_INSTANT_DOWNLOAD: 29,
}

function isInstantDelivery(id) {
    return Object.values(INSTANT_DELIVERY_TYPES).indexOf(id) > -1
}

export {
    isCourieredDelivery,
    INSTANT_DELIVERY_TYPES,
    isInstantDelivery,
    TICKETMASTER_DELIVERY_TYPES
}
